import { ClinicalContext, VariantData } from '../types';

export async function analyzeVariant(userQuery: string, clinicalContext?: ClinicalContext | null): Promise<VariantData> {
  const response = await fetch('/api/analyze_variant', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: userQuery,
      clinicalContext: clinicalContext ?? null,
    }),
  });

  const rawText = await response.text();
  let data: unknown = null;

  try {
    data = rawText ? JSON.parse(rawText) : null;
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message =
      (data && typeof data === 'object' && 'detail' in data && typeof (data as any).detail === 'string' && (data as any).detail)
      || rawText
      || 'Failed to analyze variant';
    throw new Error(message);
  }

  return data as VariantData;
}
